export default __webpack_public_path__ + "static/media/防癌险.4466689c.jpg";